import { createAction } from '@reduxjs/toolkit'

import { WidgetTagObject } from 'types/GlobalWidgetTag'

// tryCreateWidgetTag
export const create = createAction('create_widget_tag')
export const createSuccess = createAction<{
  data: WidgetTagObject
  widgetId: string
}>('create_widget_tag_success')
export const createFailed = createAction('create_widget_tag_failed')

// tryUpdateWidgetTag
export const update = createAction('update_widget_tag')
export const updateSuccess = createAction<{
  data: WidgetTagObject
  widgetId: string
}>('update_widget_tag_success')
export const updateFailed = createAction('update_widget_tag_failed')

// tryDeleteWidgetTag
export const destroy = createAction('destroy_widget_tag')
export const destroySuccess = createAction<{
  id: string
  widgetId: string
}>('destroy_widget_tag_success')
export const destroyFailed = createAction('destroy_widget_tag_failed')
